// Single source of truth: mapping van route-pad -> routeKey (page-key in de rollenmatrix).
// Deze keys moeten 1-op-1 overeenkomen met PageCatalog in de API (module Platform), gegenereerd naar
// src/config/generated/pageCatalog.json.
// De vitest-policyguard (src/config/__tests__/routeKeys.policy.test.js) bewaakt dat.
// Meerdere paden mogen naar dezelfde routeKey mappen.
export const ROUTE_KEYS = {
  "/": "home",
  "/worklist": "worklist",
  // Issue #84: basisrapportering (ook voor de rol Vermogen).
  "/rapportage": "reporting",
  "/market-rates": "marketRates",
  "/assets": "assets",
  "/fixed-income": "fixedIncome",
  "/term-deposits": "termDeposits",
  "/contracts": "contracts",
  "/saa": "saa",
  "/market-data-bootstrap": "marketDataBootstrap",
  "/portfolio-upload": "portfolioUpload",
  "/cashflow-forecast": "cashflowForecast",
  "/cashflow-forecast-upload": "cashflowForecastUpload",
  "/bankflow": "bankflow",
  "/bank-import": "bankImport",
  "/bank-processing": "bankProcessing",
  "/bank-documents": "bankDocuments",
  "/bank-profiles": "bankProfiles",
  "/bestandsbeheer": "fileManagement",
  "/exact-online": "exactOnline",
  "/exact-online/journals": "exactJournals",
  "/exact-online/general-ledger": "exactGL",
  "/diagnostics": "diagnostics",
  "/lookups": "lookups",
  "/legal-entities": "legalEntities",
  // Issue #23: banken als eigen stamdata (dim_bank) en de beheerpagina Toegang (rollen + bereik per persoon).
  "/banken": "banks",
  "/toegang": "access",
  "/feedback": "feedback",
  // Issue #23 (F4): de MCP-bevestigingslink (confirm_url) wijst naar /te-bevestigen; audit = Beheer of Vermogen Alles.
  "/te-bevestigen": "pendingActions",
  "/audit": "audit",
};
